import { X } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface FilterChipProps {
  label: string;
  onClear: () => void;
  className?: string;
}

export function FilterChip({ label, onClear, className }: FilterChipProps) {
  return (
    <span
      className={cn(
        'text-meta-sm bg-primary-50 text-primary-700 inline-flex items-center gap-1.5 rounded-sm px-2 py-1',
        className,
      )}
    >
      {label}
      <button
        type="button"
        onClick={onClear}
        aria-label={`Clear ${label}`}
        className={cn(
          'text-primary-700/80 inline-flex h-4 w-4 items-center justify-center rounded-sm',
          'hover:bg-primary-100 hover:text-primary-700',
          'focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none',
        )}
      >
        <X className="h-3 w-3" strokeWidth={1.5} />
      </button>
    </span>
  );
}
